import Vue from 'vue';
import Router from 'vue-router';
import AskGameCode from './views/AskGameCode.vue';
import PlayerWelcome from './views/PlayerWelcome.vue';
import SelfEvaluation from './views/SelfEvaluation.vue';
import Login from './views/admin/Login.vue';
import Games from './views/admin/Games.vue';
import GamesHistory from './views/admin/GamesHistory.vue';
import FirstPage from './views/FirstPage.vue';
import Intro from './views/Intro.vue';
import Game from './views/Game.vue';
import LastPage from './views/LastPage.vue';
import GamesDialog from './views/admin/GamesDialog.vue';
import Reporting from './views/Reporting.vue';
import ForgotPassword from './views/admin/ForgotPassword.vue'
import ChangePassword from './views/admin/ChangePassword.vue'
import AskGameName from './views/admin/AskGameName.vue'
import AdminGuide from './views/admin/AdminGuide.vue'
import RelationsTester from './views/RelationsTester.vue'
import RelationsEChartsTester from './views/RelationsEChartsTester.vue'
import RpsFirstPage from './views/rps/FirstPage.vue';
import RpsGame from './views/rps/Game.vue';
import RpsLastPage from './views/rps/LastPage.vue';
import RpsReporting from './views/rps/Reporting.vue';
import RpsLobby from './views/rps/Lobby.vue';
import ScenarioEditor from './views/admin/ScenarioEditor.vue'
import EditorHome from './views/admin/EditorHome.vue'
import GameLinksDialog from '@/components/GameLinksDialog.vue'
import LimitedFacilitatorGamesDialog from './views/admin/LimitedFacilitatorGamesDialog.vue'
import SimulationPhotoEditor from '@/views/admin/SimulationPhotoEditor.vue'
import CombinationReportHome from './views/admin/CombinationReportHome.vue'
import ScenarioBrowser from './views/admin/ScenarioBrowser.vue'
import Feedback from './components/Feedback.vue';
import ListFeedback from './components/ListFeedback.vue';

// import RelationsCytoscape from '@/components/RelationsCytoscape.vue';
// import RelationsCytoscapeTester from '@/components/RelationsCytoscapeTester.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/gamelinks/:gamecode',
      name: 'GameLinks',
      component: GameLinksDialog,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/',
      name: 'home',
      component: AskGameCode,
    },
    {
      path: '/welcome',
      name: 'PlayerWelcome',
      component: PlayerWelcome,
      meta: {
        requiresGameCode: true
      },
    },
    {
      path: '/welcome/returncode/:returncode',
      name: 'PlayerWelcomeReturncode',
      component: PlayerWelcome,
      meta: {
        requiresGameCode: true
      },
    },
    {
      path: '/selfevaluation',
      name: 'SelfEvaluation',
      component: SelfEvaluation,
      meta: {
        requiresGameCode: true
      },
    },
    {
      path: '/begin',
      name: 'FirstPage',
      component: FirstPage,
      meta: {
        requiresGameCode: true
      },
    },
    {
      path: '/rps/lobby',
      name: 'RpsLobby',
      component: RpsLobby,
      meta: {
        requiresGameCode: true
      },
    },
    {
      path: '/rps/begin',
      name: 'RpsFirstPage',
      component: RpsFirstPage,
      meta: {
        requiresGameCode: true
      },
    },
    {
      path: '/rps/end',
      name: 'RpsLastPage',
      component: RpsLastPage,
      meta: {
        requiresGameCode: true
      },
    },
    {
      path: '/game/:case',
      name: 'Game',
      component: Game,
      meta: {
        requiresGameCode: true
      },
    },
    {
      path: '/rps/game/:case',
      name: 'RpsGame',
      component: RpsGame,
      meta: {
        requiresGameCode: true
      },
    },
    {
      path: '/end',
      name: 'LastPage',
      component: LastPage,
      meta: {
        requiresGameCode: true
      },
    },
    {
      path: '/admin/guide',
      name: 'adminguide',
      component: AdminGuide,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/games',
      name: 'admingames',
      component: Games,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/gameshistory',
      name: 'admingameshistory',
      component: GamesHistory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/games/edit/:gameid',
      name: 'admingamesdialogedit',
      component: GamesDialog,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/games/editphotos/:rpsscenarioid',
      name: 'admingameseditphotos',
      component: SimulationPhotoEditor,
      meta: {
        requiresAuth: true
      }
    },  
    {
      path: '/admin/games/create',
      name: 'admingamesdialogcreate',
      component: GamesDialog,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/askgamename/id/:id/gamecode/:gamecode',
      name: 'askgamename',
      component: AskGameName,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/practice/gamecode/:gamecode',
      name: 'admingamesdialogpracticelimited',
      component: GamesDialog,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/games/:practice/',
      name: 'admingamesdialogpractice',
      component: GamesDialog,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin/games/limited-facilitator/create',
      name: 'admingamesdialoglimitedfacilitator',
      component: LimitedFacilitatorGamesDialog,
      meta: {
        requiresAuth: true
      }
    },    
    {
      path: '/admin/login',
      name: 'adminlogin',
      component: Login,
    },
    {
      path: '/admin/login/expired/:expired',
      name: 'adminloginexpired',
      component: Login,
    },
    {
      path: '/admin/forgotpassword',
      name: 'adminforgotpassword',
      component: ForgotPassword,
    },
    {
      path: '/admin/forgotpassword/email/:email',
      name: 'adminforgotpasswordemail',
      component: ForgotPassword,
    },
    {
      path: '/admin/setpassword',
      name: 'adminsetpassword',
      component: ForgotPassword,
    },
    {
      path: '/admin/changepassword/email/:email/token/:token',
      name: 'adminchangepassword',
      component: ChangePassword,
    },
    {
      path: '/admin/scenariobrowser/',
      name: 'adminscenariobrowser',
      component: ScenarioBrowser,
      meta: {
        requiresAuth: true
      }      
    },
    { 
      path: '/admin/scenarioeditor/new',
      name: 'adminscenarioeditornew',
      component: ScenarioEditor,
      meta: {
        requiresAuth: true
      }      
    },
    {
      path: '/admin/scenarioeditor/edit/:rpsscenarioid',
      name: 'adminscenarioeditoredit',
      component: ScenarioEditor,
      meta: {
        requiresAuth: true
      }      
    },
    {
      path: '/admin/scenarioeditor/edit/:rpsscenarioid/save/:saved/locale/:locale',
      name: 'adminscenarioeditoreditsaved',
      component: ScenarioEditor,
      meta: {
        requiresAuth: true
      }      
    },
    {
      path: '/admin/combinationreport',
      name: 'combinationreporthome',
      component: CombinationReportHome,
      meta: {
        requiresAuth: true
      }      
    },
    {
      path: '/admin/editor',
      name: 'admineditor',
      component: EditorHome,
      meta: {
        requiresAuth: true
      }      
    },
    {
      path: '/feedback/gamecode/:gamecode',
      name: 'feedback',
      component: ListFeedback,
      meta: {
        requiresAuth: true
      }      
    },    
    {
      path: '/gamecode/:gamecode/returncode/:returncode',
      name: 'gamecodewithreturn',
      component: AskGameCode,
    },
    {
      path: '/gamecode/:gamecode',
      name: 'gamecode',
      component: AskGameCode,
    },
    {
      path: '/observe/gamecode/:gamecode',
      name: 'observe',
      component: AskGameCode,
    },
    {
      path: '/rps/reporting',
      name: 'RpsReporting',
      component: RpsReporting,
    },
    {
      path: '/reporting',
      name: 'reporting',
      component: Reporting,
    },    
    {
      path: '/reporting/print/:print',
      name: 'reporting_with_print',
      component: Reporting,
    },
    {
      path: '/reporting/gamecode/:gamecode',
      name: 'reporting_with_gamecode',
      component: Reporting,
    },
    {
      path: '/rps/reporting/gamecode/:gamecode',
      name: 'rps_reporting_with_gamecode',
      component: RpsReporting,
    },
    {
      path: '/reporting/gamecode/:gamecode/print/:print',
      name: 'reporting_with_gamecode_and_print',
      component: Reporting,
    },
    {
      path: '/reporting/reportingcode/:reportingcode',
      name: 'reporting_with_reportingcode',
      component: Reporting,
    },
    {
      path: '/rps/reporting/reportingcode/:reportingcode',
      name: 'rps_reporting_with_reportingcode',
      component: RpsReporting,
    },
    {
      path: '/reporting/reportingcode/:reportingcode/print/:print',
      name: 'reporting_with_reportingcode_and_print',
      component: Reporting,
    },
    {
      path: '/relations',
      name: 'relations',
      component: RelationsTester,
    },
    {
      path: '/echarts',
      name: 'echarts',
      component: RelationsEChartsTester,
    },
    {
      path: '/intro',
      name: 'intro',
      component: Intro,
    },

     /*
    {
      path: '/tester',
      name: 'tester',
      component: RelationsCytoscapeTester,
    },        */
    {
      path: "*",
      redirect: "/"
    }
  ],
});
